import Api from '@/services/Api'

export default {
    getAllSubsidiaryByComp(id){
        return Api().get('subsidiaryByCompany/'+ id)
    },
    createMatrizSubsi(form){
        return Api().post('subsidiary/asociaMatrizSub',form)
    }
}